module.exports = "/_next/static/images/scam_nft_000-77a9f585b35f5ac8d3e9b01c1ae0aed1.png";